<!--
/**
 * angular-admin-oskey-io
 *
 * @license
 * Copyright (c) 2021-2025, OSKEY SAS. All rights reserved.
 *
 * The source code is protected under international copyright law.
 * All rights reserved and protected by the copyright holders.
 *
 * The source code is confidential and only available to authorized individuals with the permission of the copyright holders.
 * If you encounter this source code and do not have permission, please contact the copyright holders and delete this file.
 */
-->
@if (authService.isLoading()) {
  <div class="loading-overlay">
    <div class="white-box">
      <osk-spinner size="lg" color="primary" />
    </div>
  </div>
}
<main>
  @if (showNavbar) {
    <osk-header></osk-header>
  }

  <div class="btn-scroll-to-top" [ngClass]="{ show: windowScrolled }">
    <osk-button
      color="neutral"
      appearance="outline"
      size="sm"
      [iconOnly]="true"
      leadingIcon="arrow-up"
      [ariaLabel]="('shared.scrollToTop' | oskTranslate | async) ?? ''"
      (clicked)="scrollToTop()"
    />
  </div>
  <div class="btn-cookie-consent-banner">
    <osk-button
      color="neutral"
      appearance="outline"
      size="sm"
      [iconOnly]="true"
      leadingIcon="shield"
      [ariaLabel]="('shared.cookieSettings' | oskTranslate | async) ?? ''"
      (clicked)="showCookieConsentBanner()"
    />
  </div>
  @if (!showProfileInfoForm) {
    <div class="sidenav-container">
      @if (isInPlatformPortal) {
        <osk-sidemenu></osk-sidemenu>
      }
      <div class="sidenav-content" [class.sidenav-content-portal]="isInPlatformPortal">
        <section>
          <router-outlet></router-outlet>
        </section>
      </div>
    </div>
  } @else {
    <section data-testId="profileForm" class="profile-form-section">
      <div class="profile-form-wrapper">
        <osk-card
          [title]="('app.provideProfileInfo' | oskTranslate | async) || ''"
          icon="user"
          padding="lg"
        >
          <form class="profile-form" [formGroup]="profileForm" (ngSubmit)="createUser()">
            <osk-form-field
              [label]="('app.firstName' | oskTranslate | async) || ''"
              forId="profile-first-name"
              [required]="true"
              [error]="
                profileForm.controls.firstName.touched &&
                profileForm.controls.firstName.hasError('required')
                  ? ('app.firstNameIs' | oskTranslate | async) +
                    ' ' +
                    ('app.required' | oskTranslate | async)
                  : ''
              "
            >
              <osk-input
                inputId="profile-first-name"
                type="text"
                [formControlName]="'firstName'"
                [invalid]="
                  profileForm.controls.firstName.touched && profileForm.controls.firstName.invalid
                "
              />
            </osk-form-field>

            <osk-form-field
              [label]="('app.lastName' | oskTranslate | async) || ''"
              forId="profile-last-name"
              [required]="true"
              [error]="
                profileForm.controls.lastName.touched &&
                profileForm.controls.lastName.hasError('required')
                  ? ('app.lastNameIs' | oskTranslate | async) +
                    ' ' +
                    ('app.required' | oskTranslate | async)
                  : ''
              "
            >
              <osk-input
                inputId="profile-last-name"
                type="text"
                [formControlName]="'lastName'"
                [invalid]="
                  profileForm.controls.lastName.touched && profileForm.controls.lastName.invalid
                "
              />
            </osk-form-field>

            <div class="profile-form-actions">
              <osk-button type="submit" color="primary" [disabled]="profileForm.invalid">
                {{ 'app.confirm' | oskTranslate | async }}
              </osk-button>
            </div>
          </form>
        </osk-card>
      </div>
    </section>
  }
</main>
<osk-app-version [version]="appVersion" />
<osk-toast-container />
